import { IBoondock, IListing, IPolicy } from '../interfaces';

export class Policy implements IPolicy {
  id?: number;
  listing?: IListing;
  boondock?: IBoondock;
  description?: string;
  custom?: boolean;

  constructor(data?: IPolicy) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IPolicy): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }
}
